import { commonKeys } from "app/components/sharingAssetModal/commonKeys";
import type { IModalText } from "app/components/sharingAssetModal/types";
import { ESharingState } from "app/components/sharingAssetModal/types";
import { i18nFilter } from "app/filters/i18nFilter";
import type { ICustomSegment } from "app/services/segments/segmentsApiService";
const i18n = i18nFilter();

export const getModalText = (
    segment: ICustomSegment,
    HEADER_TITLE_KEY = "shared.segments.modal.title",
    NOTIFICATION_KEY = "segment.sharing.modal.options.users.subtitle.notification.default.content",
    ): IModalText => {
    const { segmentName, domain } = segment;
    const domainAndSegmentNameText = segmentName ? ` ${domain} · ${segmentName}` : ` ${domain}`;
    const subtitleReplacement = { domainAndSegmentNameText };

    return {
        header: {
            title: i18n(HEADER_TITLE_KEY),
            subtitle: i18n("shared.segments.modal.subtitle", subtitleReplacement),
        },
        sharingStateContainer: {
            [ESharingState.PRIVATE]: {
                title: i18n(commonKeys.sharingStateContainer[ESharingState.PRIVATE].title),
                subtitle: i18n("segment.sharing.modal.options.private.subtitle"),
            },
            [ESharingState.ACCOUNT]: {
                title: i18n(commonKeys.sharingStateContainer[ESharingState.ACCOUNT].title),
                subtitle: i18n("segment.sharing.modal.options.account.subtitle"),
            },
            [ESharingState.SUBSET_OF_USERS]: {
                title: i18n(commonKeys.sharingStateContainer[ESharingState.SUBSET_OF_USERS].title),
                subtitle: i18n("segment.sharing.modal.options.users.subtitle"),
                notificationDefaultContent: i18n(NOTIFICATION_KEY, {
                    domainAndSegmentNameText,
                    waveIcon: "👋",
                }),
            },
        },
    };
};

export const getBulkModalText = (segmentCount: number): IModalText => {
    return {
        header: {
            title: i18n("segments.bulk.share.modal.title"),
            subtitle: i18n("segments.bulk.share.modal.subtitle", { count: segmentCount }),
        },
        sharingStateContainer: {
            [ESharingState.PRIVATE]: {
                title: i18n(commonKeys.sharingStateContainer[ESharingState.PRIVATE].title),
                subtitle: i18n("segment.sharing.modal.options.private.subtitle"),
            },
            [ESharingState.ACCOUNT]: {
                title: i18n(commonKeys.sharingStateContainer[ESharingState.ACCOUNT].title),
                subtitle: i18n("segment.sharing.modal.options.account.subtitle"),
            },
            [ESharingState.SUBSET_OF_USERS]: {
                title: i18n(commonKeys.sharingStateContainer[ESharingState.SUBSET_OF_USERS].title),
                subtitle: i18n("segment.sharing.modal.options.users.subtitle"),
                notificationDefaultContent: i18n("segments.bulk.share.modal.notification.default.content"),
            },
        },
    };
};
